import React from 'react';
import i18n from '../../../localization/i18n';
import * as rk from '../../../localization/resourceKeys';
import BannerNotification from '../common/banner/bannerNotification';

const MyVWMaintenance: React.FC = () => {
  return (
    <div className="container u-ph-small u-pv-small">
      <BannerNotification notificationStyle="error">
        {i18n.t(rk.TEXT_MAINTENANCE_MODE)}
      </BannerNotification>
    </div>
  );
};

export default MyVWMaintenance;
